import axios from 'axios';
import ApiGet from '../sections/mainheader/apiget';

class SchemeDefinationService {

    constructor(apiUrl) {
        this.GetApiUrl = apiUrl;
        const docApi = apiUrl;
        const modifiedUrl = docApi.replace('api/', '');
        this.SchemeDocuments = (id, docName) =>
            axios.get(`${modifiedUrl}SchemeDocument/${id}/${docName}`, { responseType: 'blob' });

        this.ViewSchemeMaster = () => (axios.get(`${this.GetApiUrl}Scheme/ViewSchemeMaster`));

        this.GetSchemeDetails = (id) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeDetails/${id}`))

        this.GetSchemeMasterControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeMasterControls`));

        this.GetSchemeCriteriaHandlingControls = () => (axios.get(`${this.GetApiUrl}scheme/GetSchemeCriteriaHandlingControls`));


        this.SearchFilter = (payload) => (axios.post(`${this.GetApiUrl}SearchFilter`, payload));


        this.GetSchemeCopySearchControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeCopySearchControls`));

        this.DisContinueScheme = (payload) => (axios.post(`${this.GetApiUrl}scheme/DisContinueScheme`, payload));

        this.DeleteScheme = (id) => (axios.post(`${this.GetApiUrl}scheme/DeleteScheme/${id}`));


        this.GetSchemeMandatoryData = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeMandatoryData`));

        this.GetNewCustomerDefinitionControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetNewCustomerDefinitionControls`));

        this.GetIsSchemeDivisionWiseControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetIsSchemeDivisionWiseControls`));

        this.GetExecutiveDefinitionControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetExecutiveDefinitionControls`));

        this.GetSchemeSlabMandatoryData = () => (axios.get(`${this.GetApiUrl}scheme/GetSchemeSlabMandatoryData`));

        this.GetPrimaryCalculationCategoryControls = () => (axios.get(`${this.GetApiUrl}scheme/GetPrimaryCalculationCategoryControls`));

        this.GetDistributorBeneficiaryControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetDistributorBeneficiaryControls`));
        this.GetSchemeConversionRateList = (payload) => (axios.post(`${this.GetApiUrl}Scheme/GetSchemeConversionRateList`, payload));

        this.Discount = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterReward/Discount`));
        this.RetailerProductWiseDiscount = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterReward/RetailerProductWiseDiscount`));

        this.FreeItem = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterReward/FreeItem`));

        this.Gift = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterReward/Gift`));

        this.Item = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterClassification/Item`));


        this.GetSchemeTargetDefinitionControls = () => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetDefinitionControls`));


        this.GetExecutiveTargetDefinitionControls = () => (axios.get(`${this.GetApiUrl}SchemeTarget/GetExecutiveTargetDefinitionControls`));

        this.Distributor = () => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetClassification/Distributor`));
        this.Retailer = () => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetClassification/Retailer`));
        this.TargetItem = () => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetClassification/Item`));


        this.GetSchemeTargetClassification = (name) => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetClassification/${name}`));


        this.GetSchemeTargetSubClassification = (payload) => (axios.get(`${this.GetApiUrl}SchemeTarget/GetSchemeTargetSubClassification?Id=${payload.Id}&TargetOn=${payload.TargetOn}&SchemeTargetClassification=${payload.SchemeTargetClassification}`));


        this.GetSchemeFilterSubClassificationItem = (payload) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterSubClassification?filterApplicationOn=${payload.filterApplicationOn}&filterClassification=${payload.filterClassification}&IsException=${payload.IsException}&SchemeId=${payload.SchemeId}`));


        this.SchemeRetailer = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterClassification/Retailer`));


        this.GetSchemeFilterSubClassificationRetailer = (payload) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterSubClassification?filterApplicationOn=${payload.filterApplicationOn}&filterClassification=${payload.filterClassification}&IsException=${payload.IsException}&SchemeId=${payload.SchemeId}`));



        this.SchemeDistributor = () => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterClassification/Distributor`));


        this.GetSchemeFilterSubClassificationDistributor = (payload) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeFilterSubClassification?filterApplicationOn=${payload.filterApplicationOn}&filterClassification=${payload.filterClassification}&IsException=${payload.IsException}&SchemeId=${payload.SchemeId}`));

        /* Scheme Definition */
        this.AddScheme = (payload) => (axios.post(`${this.GetApiUrl}Scheme/AddScheme`, payload))
        this.UpdateScheme = (payload) => (axios.post(`${this.GetApiUrl}Scheme/UpdateScheme`, payload))
        this.SchemeSearch = (payload) => (axios.post(`${this.GetApiUrl}scheme/SearchScheme`, payload))
        this.GetSchemeAutocompleteText = (payload) => (axios.post(`${this.GetApiUrl}Scheme/GetSchemeAutocompleteText`, payload))

        /* Scheme Point */

        this.GetSchemePointControls = (id) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemePointControls/${id}`))

        /* Scheme Point */
        this.GetSecondarySchemesSlabRepeatationCriteriaControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetSecondarySchemesSlabRepeatationCriteriaControls`));

        /* Scheme Area */
        this.GetArea = (id) => (axios.get(`${this.GetApiUrl}Area/GetAreaTree/${id}`));
        this.GetSchemeAreaDetails = (id) => (axios.get(`${this.GetApiUrl}Scheme/GetSchemeAreaDetails/${id}`));

        /* Scheme Area */

        this.GetContributionItems = (payload) => (axios.post(`${this.GetApiUrl}scheme/GetContributionItems`, payload));
        this.SchemeTargetAutoComplete = (payload) => (axios.post(`${this.GetApiUrl}SchemeTarget/SchemeTargetAutoComplete`, payload));


        this.autocompleteSearchFilter = (payload) => (axios.post(`${this.GetApiUrl}Scheme/SearchSchemeFilter`, payload));


        this.ConditionalCriteriaControls = () => (axios.get(`${this.GetApiUrl}Scheme/GetConditionalCriteriaControls`)); 


        this.GetThresholdSetting = () => (axios.get(`${this.GetApiUrl}Claim/GetThresholdSetting`)); 





    }
}
export default ApiGet().then((apiUrl) => new SchemeDefinationService(apiUrl));
